import useTokenStore from "store/tokenStore";
import { useMutation } from "react-query";
import toast from "react-hot-toast";
import ServerErrors from "components/SeverErrors";
import InitApi from "api/InitApi";
const usePublishPermissions = () => {
	const { accessToken } = useTokenStore();

	const save = async () => {
		const instance = await InitApi({ accessToken });
		const res = await instance.post("/publish-permissions");
		return res.data;
	};

	return useMutation(save, {
		onSuccess: async (data) => {
			toast.success(data?.message);
		},
		onError: async (error) => {
			const errorMessage =
				error?.response?.data?.message || "Error publishing permissions";
			toast.error(<ServerErrors errorMessage={errorMessage} />, {
				className: "max-w-max",
			});
		},
	});
};

export default usePublishPermissions;
